import {
  ExpensesInput,
  ExpensesOutput,
  ExpensesQueryParams,
} from "@/interfaces/expenses";
import { BaseService } from "./BaseService";

export class ExpensesService extends BaseService<
  ExpensesInput,
  ExpensesOutput,
  ExpensesQueryParams
> {
  constructor() {
    super();
    this.path = "expenses";
  }
}
